"use strict";

// import '../lib/smooth-scroll/smooth-scroll.polyfills.min.js';

//読み込みが完了
 $(window).on('load',function () { 
  console.log('jQuery Page Loaded.');  
});

// ページ内スクロール
$('a[href^="#"]').click(function(){
  var speed = 200;
  var href= $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top;
  $("html, body").animate({scrollTop:position}, speed, "linear");
  return false;
});

$(window).on('load scroll',function () { 
  if ($(this).scrollTop() > 150) {
    $(".ly_wrapper_front").addClass('js-open');
  } else {
    $(".ly_wrapper_front").removeClass('js-open');
  }
  if ($(this).scrollTop() > 300) {
    $(".bl_frontHero_heading").addClass('js-open');
    $(".bl_frontHero_button").addClass('js-open');
  } else {
    $(".bl_frontHero_heading").removeClass('js-open');
    $(".bl_frontHero_button").removeClass('js-open');
  }
});

// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
  console.log('DOM Content Loaded.');

  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];
  
  var menuParent = document.getElementsByClassName('menu-item-has-children');
  for( var i = 0; i < menuParent.length; i++ ) {
    menuParent[i].insertAdjacentHTML('afterbegin','<div class="toggle-submenu close"></div>');
  }

  // var spmenubtn = document.querySelectorAll('.toggle-submenu');
  var spmenubtn = document.getElementsByClassName('toggle-submenu');
  for (let i = 0; i < spmenubtn.length; i++) {
    // fuga[i]で現在の要素を指定
    spmenubtn[i].addEventListener('click', function() {
      spmenubtn[i].classList.toggle('close');
      spmenubtn[i].classList.toggle('open');
    }, false);
  }

  // var scroll = new SmoothScroll('a[href*="#"]',{
  //   // header: '[data-scroll-header]'
  // });

  var state = false;
  var scrollpos;
  var menuIcon = document.getElementById('menu-icon');
  var menuBackground = document.getElementById('menu-background');
  var body = document.querySelectorAll('body')[0];

  function scrollStop() {
    if(state == false) {
      scrollpos = window.scrollY;
      body.classList.add('js-fixed');
      body.style.top = -scrollpos + 'px';
      // $('body').addClass('js-fixed').css({'top': -scrollpos});
      state = true;
    } else {
      body.classList.remove('js-fixed');
      body.style.top = 0;
      // $('body').removeClass('js-fixed').css({'top': 0});
      window.scrollTo( 0 , scrollpos );
      state = false;
    }
  }

  // menuIcon.addEventListener('click',scrollStop);
  // menuBackground.addEventListener('click',scrollStop);

}, false);

// 完全に読み込み完了
window.addEventListener('load', function() {
  console.log('Page Loaded.');
});

//ajax読み込み
// read_urlのread_id要素を取得し、output_idに表示する
function areaLoad(read_url,read_id,output_id){
  $(function(){
      $.ajax({ 
          type: "GET", 
          url: read_url, 
          dataType: "html", 
          cache: false
      }).done(function(html){
        var wk_html = $(html).filter(read_id);
        $(output_id).html(wk_html)
      }).fail(function(){
        $(output_id).html('<p>読み込みエラー</p>')
      }).always(function(){
        console.log('complete');
      }); 
  }); 
}

$(function(){
  $('.bl_menuMain_header li a').each(function(){
      var $href = $(this).attr('href');

      $href=$href.replace(/[^/]+$/, '');
      var $wkhref=location.href;
      // console.log($href+' : '+$wkhref);

      if($wkhref.match($href)) {
          $(this).parent().addClass('is-current');
      } else {
          $(this).parent().removeClass('is-current');
      }
  });
  
  // PDFファイルリンクに target="_blank"を付ける
  $("a[href*='.pdf'],a[href*='.pptx'],a[href*='.ppt'],a[href*='.key']").attr("target","_blank");
});